import { render } from "./Development.vue?vue&type=template&id=8597eeb8&scoped=true"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"

import "./Development.vue?vue&type=style&index=0&id=8597eeb8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8597eeb8"]])

export default __exports__